import React, { useEffect, useState } from "react";
import "./cardSlid.scss";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Card from "../../components/Card/Card";
import axios from "axios";
import Loading from "../loading/Loading";

const CardSlid = ({ type }) => {
  const [selectType, setSelectType] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!type) return;

    const getType = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/get-type?type=${type}`);
        const filteredSorted = response.data
          .filter((item) => !item.outofstock)
          .sort((a, b) => a.price - b.price)
          .slice(0, 50);
        setSelectType(filteredSorted);
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    getType();
  }, [type]);

  const options = {
    loop: true,
    responsiveClass: true,
    center: true,
    margin: 20,
    autoplay: true,
    autoplayTimeout: 6500,
    smartSpeed: 350,
    nav: true,
    dots: false,
    rtl: false,
    navText: [
      "<span class='custom-prev'>◀</span>",
      "<span class='custom-next'>▶</span>",
    ],
    responsive: {
      0: { items: 1 },
      600: { items: 3 },
      1000: { items: 5 },
    },
  };

  if (error) return <p>{error}</p>;
  if (loading) return <Loading />;

  return (
    <div className="card_slid">
      <div className="___heading_main">
        <h3>
          Top Selling <em>products</em>
        </h3>
      </div>
      <div className="slideShow">
        <OwlCarousel className="owl-theme" {...options}>
          {selectType.map((item) => (
            <Card item={item} key={item._id} state={{ id: item._id }} />
          ))}
        </OwlCarousel>
      </div>
    </div>
  );
};

export default CardSlid;
